import {
  companyHasProfile,
  companyHasAnyProfile,
  getCompanyProfiles,
  getSelectedCompanyProfiles,
} from "../utils/activityProfiles";

const STANDARD_PRODUCTION_TERMINOLOGY = {
  moduleTitle: "Gestion Production",
  unitsTitle: "Unités de production",
  unitsTitleShort: "Unités",
  unitsTabTitle: "Unités",
  unitSingular: "unité de production",
  unitSingularTitle: "Unité de production",
  unitPlural: "unités de production",
  manageTitle: "Gérer la production",
  processTitle: "Production",
  processPlural: "productions",
  processPluralTitle: "Productions",
  processTabTitle: "Production",
  kitchenTabTitle: "Cuisine",
  historyTitle: "Historique productions",
  historyTabTitle: "Historique productions",
  historyTitleLong: "Historique des productions",
  costTrackingTitle: "Suivi des coûts de production",
  costTotalLabel: "Coût total production",
  costByUnitTitle: "Coûts par unité",
  requestedQuantityLabel: "Production demandée",
  outputQuantityLabel: "Quantité à produire",
  defaultOutputQuantityLabel: "Qté production (défaut)",
  launchAction: "Lancer la production",
  actionVerb: "Produire",
  successMessage: "Production effectuée avec succès",
  offlineSuccessMessage:
    "Production enregistrée localement. La synchronisation sera tentée au retour de la connexion.",
  detailsTitle: "Détails de l'unité de production",
  createUnitTitle: "Créer une unité de production",
  editUnitTitle: "Modifier l'unité de production",
  addUnitAction: "Ajouter une unité de production",
  unitNameLabel: "Nom de l'unité de production",
  unitImageLabel: "Image de l'unité de production",
  unitStatusLabel: "Statut de l'unité de production",
  stockSettingsTitle: "Paramètres de stock de l'unité de production",
  historyDetailsTitle: "Détails de la production",
  dateLabel: "Date de production",
  outputProduct: "Produit fini",
  outputProducts: "Produits finis",
  outputProductsObtained: "Produits finis obtenus",
  materialsTitle: "Matières premières",
  materialSingular: "matière première",
  materialSingularTitle: "Matière première",
  materialDefiniteSingular: "la matière première",
  materialIndefiniteSingular: "une matière première",
  materialPartitiveSingular: "d'une matière première",
  materialOfAtLeastOne: "d'au moins une matière première",
  materialDemonstrativeSingular: "cette matière première",
  materialAddedAgreement: "ajoutée",
  materialPlural: "matières premières",
  materialPluralTitle: "Matières premières",
  staleMaterialsSentenceStart:
    "Certaines matières premières en saisie directe restent calibrées",
  cumulativeMaterialsTitle: "Matières premières cumulées",
  consumedMaterialsTitle: "Matières premières consommées",
  analyzedMaterialsLabel: "Matières premières analysées",
  totalMaterialsLabel: "Total matières premières",
  materialQuantityLabel: "Qté matière première",
  selectMaterialPlaceholder: "Sélectionner une matière première",
  addMaterialAction: "Ajouter une matière première",
  removeMaterialAction: "Retirer la matière première",
  noMaterialFound: "Aucune matière première",
  noMaterialAdded: "Aucune matière première ajoutée",
  noMaterialDetected: "Aucune matière première détectée",
  noUsableMaterialSentence:
    "Votre établissement ne contient encore aucune matière première exploitable.",
  noMaterialAssociatedSentence:
    "Aucune matière première n'est associée à cette production.",
  configurationSingular: "configuration de production",
  configurationSingularTitle: "Configuration de production",
  configurationPlural: "configurations de production",
  configurationPluralTitle: "Configurations de production",
  configurationVersionLabel: "Version de la configuration de production",
  configurationVersionAndControlTitle:
    "Version de la configuration de production et contrôle pré-lancement",
  configurationRecentlyModifiedLabel:
    "Configuration de production modifiée récemment",
  configurationLastUpdatedLabel:
    "Dernière mise à jour de la configuration de production",
  configurationReviewTitle: "Configuration de production à vérifier",
  newMaterialsOrArticlesDescription:
    "Nouvelles matières premières ou nouveaux articles qui seront ajoutés.",
  usageProfileSingular: "profil de consommation",
  usageProfileSingularTitle: "Profil de consommation",
  similarConfigurationsTitle: "Unités de production similaires détectées",
  frequentMaterialsTitle: "Matières premières souvent ajoutées",
  costContext: "production",
  noUnitFound: "Aucune unité de production trouvée",
};

const RESTAURANT_PRODUCTION_TERMINOLOGY = {
  moduleTitle: "Gestion Cuisine",
  unitsTitle: "Unités de recette",
  unitsTitleShort: "Unités de recette",
  unitsTabTitle: "Mes Recettes",
  unitSingular: "unité de recette",
  unitSingularTitle: "Unité de recette",
  unitPlural: "unités de recette",
  manageTitle: "Gérer la cuisine",
  processTitle: "Cuisine",
  processPlural: "préparations",
  processPluralTitle: "Préparations",
  processTabTitle: "Cuisine - Préparation",
  kitchenTabTitle: "Commandes en cuisine",
  historyTitle: "Historique cuisine",
  historyTabTitle: "Historique des préparations - Cuisine",
  historyTitleLong: "Historique de cuisine",
  costTrackingTitle: "Suivi des coûts de cuisine",
  costTotalLabel: "Coût total cuisine",
  costByUnitTitle: "Coûts par recette",
  requestedQuantityLabel: "Cuisine demandée",
  outputQuantityLabel: "Quantité à cuisiner",
  defaultOutputQuantityLabel: "Qté cuisine (défaut)",
  launchAction: "Lancer la cuisine",
  actionVerb: "Cuisiner",
  successMessage: "Cuisine enregistrée avec succès",
  offlineSuccessMessage:
    "Cuisine enregistrée localement. La synchronisation sera tentée au retour de la connexion.",
  detailsTitle: "Détails de l'unité de recette",
  createUnitTitle: "Créer une unité de recette",
  editUnitTitle: "Modifier l'unité de recette",
  addUnitAction: "Ajouter une unité de recette",
  unitNameLabel: "Nom de l'unité de recette",
  unitImageLabel: "Image de l'unité de recette",
  unitStatusLabel: "Statut de l'unité de recette",
  stockSettingsTitle: "Paramètres de stock de l'unité de recette",
  historyDetailsTitle: "Détails de la cuisine",
  dateLabel: "Date de cuisine",
  outputProduct: "Plat / produit fini",
  outputProducts: "Plats / produits finis",
  outputProductsObtained: "Plats obtenus",
  materialsTitle: "Ingrédients",
  materialSingular: "ingrédient",
  materialSingularTitle: "Ingrédient",
  materialDefiniteSingular: "l'ingrédient",
  materialIndefiniteSingular: "un ingrédient",
  materialPartitiveSingular: "d'un ingrédient",
  materialOfAtLeastOne: "d'au moins un ingrédient",
  materialDemonstrativeSingular: "cet ingrédient",
  materialAddedAgreement: "ajouté",
  materialPlural: "ingrédients",
  materialPluralTitle: "Ingrédients",
  staleMaterialsSentenceStart:
    "Certains ingrédients en saisie directe restent calibrés",
  cumulativeMaterialsTitle: "Ingrédients cumulés",
  consumedMaterialsTitle: "Ingrédients consommés",
  analyzedMaterialsLabel: "Ingrédients analysés",
  totalMaterialsLabel: "Total ingrédients",
  materialQuantityLabel: "Qté ingrédient",
  selectMaterialPlaceholder: "Sélectionner un ingrédient",
  addMaterialAction: "Ajouter un ingrédient",
  removeMaterialAction: "Retirer l'ingrédient",
  noMaterialFound: "Aucun ingrédient",
  noMaterialAdded: "Aucun ingrédient ajouté",
  noMaterialDetected: "Aucun ingrédient détecté",
  noUsableMaterialSentence:
    "Votre établissement ne contient encore aucun ingrédient exploitable.",
  noMaterialAssociatedSentence:
    "Aucun ingrédient n'est associé à cette préparation.",
  configurationSingular: "recette",
  configurationSingularTitle: "Recette",
  configurationPlural: "recettes",
  configurationPluralTitle: "Recettes",
  configurationVersionLabel: "Version recette",
  configurationVersionAndControlTitle:
    "Version de recette et contrôle pré-lancement",
  configurationRecentlyModifiedLabel: "Recette modifiée récemment",
  configurationLastUpdatedLabel: "Dernière mise à jour de la recette",
  configurationReviewTitle: "Recette à vérifier",
  newMaterialsOrArticlesDescription:
    "Nouveaux ingrédients ou articles qui seront ajoutés.",
  usageProfileSingular: "profil recette",
  usageProfileSingularTitle: "Profil de recette",
  similarConfigurationsTitle: "Recettes similaires détectées",
  frequentMaterialsTitle: "Ingrédients souvent ajoutés",
  costContext: "cuisine",
  noUnitFound: "Aucune unité de recette trouvée",
};

// Set-aware : vrai si "restaurant" figure PARMI les profils cumules.
export const isRestaurantCompanyProfile = (userOrCompany) =>
  companyHasProfile(userOrCompany, "restaurant");

// La terminologie culinaire s'applique aux deux profils explicitement
// alimentaires. Les boulangeries gardent le vocabulaire generique de
// production tant qu'elles n'ont pas aussi un profil restauration/fast-food.
export const CULINARY_PRODUCTION_PROFILES = ["restaurant", "fast_food"];

export const isCulinaryCompanyProfile = (userOrCompany) =>
  companyHasAnyProfile(userOrCompany, CULINARY_PRODUCTION_PROFILES);

// Profils d'activite eligibles aux packs d'initialisation restauration
// (packs statiques "Packs rapides" + import de menu). Miroir cote frontend de
// RECIPE_ASSISTANT_ELIGIBLE_PROFILES (services/companyActivityProfiles.js) :
// tenir les deux listes synchronisees.
export const PRODUCTION_PACK_ELIGIBLE_PROFILES = [
  "restaurant",
  "fast_food",
  "bakery",
];

// Profil PRINCIPAL de l'entreprise (1er de l'ensemble cumule). Conserve pour la
// terminologie / affichages qui n'ont besoin que d'un profil.
export const getCompanyActivityProfile = (userOrCompany) =>
  getCompanyProfiles(userOrCompany)[0] || "";

// Vrai si AU MOINS un profil est restauration / fast-food / boulangerie. Pour
// les autres profils (retail, e-commerce...), on masque les packs restauration
// statiques et l'import de menu : seules les "Recettes suggerees" (deja scopees
// par profil) restent proposees.
export const isProductionPackEligible = (userOrCompany) =>
  companyHasAnyProfile(userOrCompany, PRODUCTION_PACK_ELIGIBLE_PROFILES);

export const getProductionTerminology = (userOrCompany) =>
  isCulinaryCompanyProfile(userOrCompany)
    ? RESTAURANT_PRODUCTION_TERMINOLOGY
    : STANDARD_PRODUCTION_TERMINOLOGY;

// Toujours resoudre les libelles depuis l'entreprise actuellement selectionnee.
// C'est indispensable pour les comptes multi-entreprises et SysAdmin : le
// profil de `user.company` peut appartenir a une autre entreprise.
export const getSelectedProductionTerminology = (user, selectedCompanyId) =>
  getProductionTerminology(
    getSelectedCompanyProfiles(user, selectedCompanyId)
  );

export const isSelectedCompanyProductionPackEligible = (
  user,
  selectedCompanyId
) =>
  isProductionPackEligible(
    getSelectedCompanyProfiles(user, selectedCompanyId)
  );
